<template>
    <div>
      <v-container class="bk-image ma-0 pa-0 primary--font" fluid>
        <transition name="fade" mode="out-in" appear>
          <v-row
            align="center"
            justify="center"
            class="login-wrap ma-0"
            :style="loginWrapStyle"
          >
            <v-col cols="10" class="light">
              <v-card
                align="center"
                justify="center"
                :max-width="options.maxWidth"
                class="mx-auto px-10 auth-card pb-5"
                :class="cardPaddingClass"
              >
                <v-row>
                  <v-col>
                    <v-img
                      justify="center"
                      class="m-auto mb-3"
                      contain
                      :src="maropostLogo"
                      :max-width="260"
                    />
                  </v-col>
                </v-row>
  
                <router-view :options="options" />
              </v-card>
            </v-col>
          </v-row>
        </transition>
  
        <div :class="footerClass">
         <span  class="text-grey-darken-3">&copy; Maropost Inc {{ year }}</span>
          <span class="mx-1 text-grey-darken-3">|</span>
          <a
            target="_blank"
            style="text-decoration:none;"
            href="https://www.maropost.com/privacy-policy/"
          >
            Privacy Policy
          </a>
        </div>
      </v-container>
    </div>
  </template>
  
  <script setup>
  import { computed, getCurrentInstance } from "vue";
  import { useDisplay } from "vuetify";
  import loginBg from "@/assets/login_image.jpeg";
  import maropostLogo from "@/assets/maropost-logo.svg";
  
  // Vuetify 3 display composable (replaces $vuetify.breakpoint)
  const display = useDisplay();
  
  // keeping same options object
  const options = {
    maxWidth: 390,
  };
  
  // your background style (same as original)
  const loginWrapStyle = computed(() => ({
    backgroundColor: "#03b6fc",
    backgroundPosition: "center",
    backgroundImage: `url(${loginBg})`,
  }));
  
  // same device detection as your original (based on width/height)
  const device = computed(() => {
    const width = display.width.value;
    const height = display.height.value;
  
    if (width === 280 && height === 653) return "galaxy-fold";
    if (width === 768 && height === 1024) return "ipad";
    if (width === 320 && height === 568) return "iphone5se";
  
    return "";
  });
  
  // same card padding behavior
  const cardPaddingClass = computed(() => {
    if (display.smAndDown.value) {
      return device.value !== "iphone5se" ? "pt-5" : "";
    }
    return "pt-10";
  });
  
  // footer class logic (same output as original)
  const footerClass = computed(() => {
    if (display.smAndDown.value) {
      return `mobile-footer-text footer-text ${device.value}`.trim();
    }
    return "footer-text";
  });
  
  // ✅ Year (supports your old $dateEST() if still exists in Vue3 globalProperties)
  const instance = getCurrentInstance();
  
  const year = computed(() => {
    const dateESTFn = instance?.appContext.config.globalProperties?.$dateEST;
  
    if (typeof dateESTFn === "function") {
      return dateESTFn().getFullYear();
    }
  
    // fallback: local year
    return new Date().getFullYear();
  });
  </script>
  
  <style>
  .bk-image {
    position: relative;
    text-align: center;
    color: white;
  }
  
  .mobile-footer-text {
    position: fixed !important;
    bottom: -24px !important;
  }
  
  .galaxy-fold {
    width: 80%;
  }
  
  .ipad {
    bottom: 0 !important;
  }
  
  .iphone5se {
    left: 50% !important;
    bottom: -8px !important;
    font-size: 13px !important;
    width: 80%;
  }
  
  .footer-text {
    position: absolute;
    bottom: 8px;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
  }
  
  iframe.post {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    top: 0;
    left: -100%;
    z-index: -1;
  }
  
  .login-wrap {
    background-color: #00aae9;
    background-size: cover;
    width: 100vw;
    height: 100vh;
  }
  
  .auth-card .custom-btn {
    text-transform: none;
    font-family: "Roboto", sans-serif !important;
  }
  
  .auth-card .custom-login {
    background-color: #4c5463 !important;
    color: #ffffff !important;
  }
  
  .login-grey--text,
  .auth-card .login-grey--text {
    color: rgba(0, 0, 0, 0.6) !important;
  }
  
  .auth-card {
    overflow: hidden;
  }
  </style>
  